import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Header from 'common/Header';
import css from './AddModal.scss';
import classnames from 'classnames';
import useStarfishAPI from 'hooks/useStarfishAPI';
import { find, sortBy } from 'lodash';
import { urlParams } from 'utils/request';
import { isEmptyString } from 'utils/text';
import { imageStyle } from 'utils/images';
import Select from 'common/StyledSelect';
import { components } from 'react-select';

const AddCalendarManagerModal = (props) => {
    const [ possibleManagersResponse, callPossibleManagersAPI ] = useStarfishAPI();
    const [ addManagerResponse, callAddManagerAPI ] = useStarfishAPI();
    const [ possibleManagers, setPossibleManagers ] = useState([]);
    const [ managerToAdd, setManagerToAdd ] = useState(null);
    const [ previouslyCalledAPIWithSearchQuery, setPreviouslyCalledAPIWithSearchQuery ] = useState(true); // forces initial load
    
    const loadPossibleManagers = (searchQuery) => {
        // if this api was last called without a search query and we don't have a search query now, don't reload
        if (isEmptyString(searchQuery) && !previouslyCalledAPIWithSearchQuery) return;
        
        callPossibleManagersAPI('../instructor/getPeopleSearchList.html', {
            method: 'POST',
            body: isEmptyString(searchQuery) ? null : urlParams({ query: searchQuery })
        }).then(() => setPreviouslyCalledAPIWithSearchQuery(!isEmptyString(searchQuery)));
    };
    
    useEffect(() => {
        if (props.isOpen) loadPossibleManagers();
        setManagerToAdd(null);
    }, [props.isOpen]);
    
    useEffect(() => {
        setPossibleManagers(possibleManagersResponse.data.result
            ? sortBy(possibleManagersResponse.data.result, 'lastName')
                .map(user => {
                    return {
                        imageStyle: imageStyle(user.uuid, user.hasPhoto),
                        label: `${user.lastName}, ${user.firstName}`,
                        value: user
                    }
                }) 
            : []);
    }, [possibleManagersResponse]);
    
    const save = () => {
        callAddManagerAPI('../instructor/addCalendarManager.html', {
            method: 'POST',
            body: urlParams({
                fullName: managerToAdd.fullName,
                calMgrId: managerToAdd.id
            })
        });
    };
    
    useEffect(() => {
        if (addManagerResponse.success) props.onSave();
    }, [addManagerResponse]);

    const possibleManagerOption = optionProps => (
        <components.Option {...optionProps} className={css['image-item']}>
            <div className={css['image']} style={optionProps.data.imageStyle} />
            <span>{ optionProps.data.label.trim() }</span>
        </components.Option>
    );
    
    return (
        <Modal isOpen={props.isOpen}
               onRequestClose={props.closeModal}
               overlayClassName={css['overlay']}
               className={css['modal']}>
            <Header closeModal={props.closeModal} />
            <div className={classnames(css['content'], {[css.ie]: props.isIE})}>
                <h1>Add Calendar Manager</h1>
                <div>
                    <label htmlFor="addManager">Search User to Add</label>
                    <Select id="addManager"
                            ariaLabel="Search User to Add"
                            isSearchable
                            isClearable
                            className={classnames(css['dropdown'], css['searchable-dropdown'])}
                            customOption={possibleManagerOption}
                            noOptionsMessage={() => "No people found"}
                            onChange={person => setManagerToAdd(person ? person.value : null)}
                            onSearchChange={searchQuery => {
                                if (isEmptyString(searchQuery) || searchQuery.length > 2) loadPossibleManagers(searchQuery)
                            }}
                            options={possibleManagers} 
                            placeholder="Add User as Calendar Manager"
                            value={find(possibleManagers, ['value', managerToAdd])} />
                </div>
            </div>
            <div className={css['actions']}>
                <button data-testid="saveManager"
                        disabled={managerToAdd === null}
                        onClick={save}>
                    Add Calendar Manager
                </button>
            </div>
        </Modal>
    );
};

AddCalendarManagerModal.propTypes = {
    closeModal: PropTypes.func,
    isIE: PropTypes.bool,
    isOpen: PropTypes.bool,
    onSave: PropTypes.func
};

export default AddCalendarManagerModal;
